export enum MODALS {
  MISC = 'misc',
  EVENT_CREATION = 'event-creation',
  LOGIN_MODAL = 'login-modal',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password',
  SIGNUP = 'signup',
  COMPLETE_ACCOUNT_MODAL = 'complete-account-modal',
  PARTNER_SIGNUP_MODAL = 'partner-signup-modal',
  PARTNER_PROFILE_MODAL = 'partner-profile-modal',
  PARTNER_SIGNUP_COMPLETED_MODAL = 'partner-signup-completed-modal',
  PARTNER_CREATE_EVENT_MODAL = 'partner-create-event-modal',
  PARTNER_CREATE_EVENT_IMAGE_MODAL = 'partner-create-event-image-modal',
  EVENT_CREATION_DEBOUNCE_POPUP = 'event-creation-debounce-popup',
  PROFILE_MODAL = 'profile-modal',
  PROFILE_CULTURE_MODAL = 'profile-culture-modal',
  PROFILE_CULTURE_CATEGORY_MODAL = 'profile-culture-category-modal',
  PROFILE_CULTURE_MUSIC_MODAL = 'profile-culture-music-modal',
  PROFILE_CULTURE_DANCE_MODAL = 'profile-culture-dance-modal',
  PROFILE_CULTURE_SPEECH_ART_MODAL = 'profile-culture-speech-art-modal',
  PROFILE_CULTURE_HUMOR_MODAL = 'profile-culture-humor-modal',
  PROFILE_CULTURE_THEATER_MODAL = 'profile-culture-theater-modal',
  PROFILE_CULTURE_CIRCUS_MODAL = 'profile-culture-circus-modal',
  PROFILE_CULTURE_VARIETIES_MODAL = 'profile-culture-varieties-modal',
  PROFILE_PERSONAL_MODAL = 'profile-personal-modal',
  PROFILE_SECURITY_MODAL = 'profile-security-modal',
  PROFILE_NOTIFICATION_MODAL = 'profile-notification-modal',
  PROFILE_FAVORITES_MODAL = 'profile-favorites-modal',
  SEARCH_CONTAINER = 'search-container',
  SEARCH_RESULTS = 'search-results',
  DISCIPLINES_DROPDOWN = 'disciplines-dropdown',
  DATES_DROPDOWN = 'dates-dropdown',
  REGION_DROPDOWN = 'region-dropdown',
  AUDIENCE_DROPDOWN = 'audience-dropdown',
  RADIUS_DROPDOWN = 'radius-dropdown',
  SEARCH_SUGGESTIONS_DROPDOWN = 'search-suggestions-dropdown',
  SORTING_DROPDOWN = 'sorting-dropdown',
  EVENT_SERIES_CALENDAR = 'event-series-calendar',
  EVENT_SERIES_LIST = 'event-series-list',
  ARTIST_SPECTACLES = 'artist-spectacles',
  PRIMARY_SLIDER = 'primary-slider',
  FAVORITE_ARTISTS = 'favorites-list',
  NEWSLETTER = 'newsletter',
  DISCOVERY = 'discovery',
  CONTACT_FORM = 'contact-form',
  VERIFY_EXHIBITION_EXISTENCE_MODAL = 'verify-exhibition-existence-modal',
  CREATE_EVENT_COMPLETED_MODAL_WRAPPER = 'create-event-completed-modal-wrapper',
  CREATE_EXHIBITION_COMPLETED_MODAL_WRAPPER = 'create-exhibition-completed-modal-wrapper',
  CONTRIBUTORS_SELECTOR = 'contributors-selector',
  HOME = 'home',
  PAGE = 'page',
  LOADING = 'loading',
  NONE = '',
  ACCOUNT_DROPDOWN = 'account-nav-dropdown',
}
